import { useSyncExternalStore } from 'react'

type Listener = () => void

const hoveredPaneByViewKey: Record<string, number | undefined> = {}
const revisionByViewKey: Record<string, number> = {}
const listenersByViewKey: Record<string, Set<Listener>> = {}

/** Notify pane chrome (move/delete stack) only when the hovered pane index changes — not on every crosshair tick. */
export function setChartHoveredPane(viewKey: string, paneIndex: number | undefined) {
    if (hoveredPaneByViewKey[viewKey] === paneIndex) return
    hoveredPaneByViewKey[viewKey] = paneIndex
    revisionByViewKey[viewKey] = (revisionByViewKey[viewKey] ?? 0) + 1
    listenersByViewKey[viewKey]?.forEach((listener) => listener())
}

export function getChartHoveredPane(viewKey: string): number | undefined {
    return hoveredPaneByViewKey[viewKey]
}

function subscribeChartHoveredPane(viewKey: string, listener: Listener) {
    if (!listenersByViewKey[viewKey]) {
        listenersByViewKey[viewKey] = new Set()
    }
    listenersByViewKey[viewKey].add(listener)
    return () => {
        listenersByViewKey[viewKey]?.delete(listener)
    }
}

export function useChartHoveredPane(viewKey: string): number | undefined {
    return useSyncExternalStore(
        (listener) => subscribeChartHoveredPane(viewKey, listener),
        () => hoveredPaneByViewKey[viewKey],
        () => undefined
    )
}
